var App = App || {};

App.WidgetFaq = (function ($) {
    'use strict';

    function Accordion(selector) {

        if (selector.length) {

            selector.each(function () {

                const accordions = $(this).find(".accordion");

                accordions.each(function () {

                    const accordion = $(this);
                    const component = $(this).parents(".widget[class*='widget-faq']");
                    const viewMore = component.find(`button[aria-controls=\"${accordion.attr("id")}\"]`);

                    viewMore.on("click", function () {
                        if ($(this).attr("aria-expanded") == "false") {
                            $(this).attr("aria-expanded", "true").children("span.text").text("View Less");
                            accordion.find(".accordion-item.d-none").addClass("accordion-item-conditional").removeClass("d-none");
                        }
                        else if ($(this).attr("aria-expanded") == "true") {
                            $(this).attr("aria-expanded", "false").children("span.text").text("View More");
                            accordion.find(".accordion-item.accordion-item-conditional").removeClass("accordion-item-conditional").addClass("d-none");
                        }
                    });
                });
            });
        }
    }

    return {
        Accordion: Accordion
    };

})(jQuery);